export default __webpack_public_path__ + "static/media/GoodMannersAtSchool_02.49652371.png";